import {SVGProps} from 'react';

const Icon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        fill="none"
        height="24"
        viewBox="0 0 24 24"
        width="24"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            clipRule="evenodd"
            d="M21.8498 18.804L13.3288 2.53669C12.7673 1.4647 11.2328 1.4647 10.6713 2.53669L2.15034 18.804C1.62718 19.8027 2.35161 21 3.47908 21H20.521C21.6485 21 22.3729 19.8027 21.8498 18.804ZM12 7.62499C12.4833 7.62499 12.875 8.01674 12.875 8.49999V13.5C12.875 13.9832 12.4833 14.375 12 14.375C11.5168 14.375 11.125 13.9832 11.125 13.5V8.49999C11.125 8.01674 11.5168 7.62499 12 7.62499ZM12 18.25C12.6904 18.25 13.25 17.6903 13.25 17C13.25 16.3096 12.6904 15.75 12 15.75C11.3097 15.75 10.75 16.3096 10.75 17C10.75 17.6903 11.3097 18.25 12 18.25Z"
            fill="currentColor"
            fillRule="evenodd"
        />
    </svg>
);

export default Icon;
